import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';

export const DefaultTextField = withStyles({
  root: {
    width: '133px',
    marginTop: '22px',
  },
})(TextField);

export const DefaultDateField = withStyles({
  root: {
    width: '133px',
    marginTop: '22px',
  },
})(TextField);

export const DefaultTimeField = withStyles({
  root: {
    width: '133px',
    marginTop: '22px',
  },
})(TextField);